import { pick } from "lodash-es"

export const blurKeys = {
  mainBlurView: "mainBlurView",
  themeButton: "themeButton",
  radioGroupView: "radioGroupView",
  checkboxGroupView: "checkboxGroupView",
  inputField: "inputField",
  ticketCard: "ticketCard",
} as const

export type BlurKey = keyof typeof blurKeys

export const createDisplayedBlurKeys = (
  keys: BlurKey[],
): Partial<typeof blurKeys> => {
  return pick(blurKeys, keys)
}
